import React from 'react';
import './styles.css';
import { Button, Row } from 'antd';
import {
  BupSpinner,
  ButtonBackData,
  DividerContainer,
  ItemImage,
  PageLayout,
} from '@BUP/components';
import Diagnostico from '@BUP/assets/Images/Data/data_diagnostico.png';
import Sociograma from '@BUP/assets/Images/Data/data_sociograma.png';
import { useHistory } from 'react-router';
import {
  useAuth,
  useBraveUpSurveysApi,
  useGetDashboardResponses,
  useGetReports,
  useGetSurveysSociogram,
} from '@BUP/hooks';
import { isSociogram } from '@BUP/services/BraveUp';
import { useTranslation } from 'react-i18next';

const DataTrackingPage = () => {
  const history = useHistory();
  const [t] = useTranslation();
  const { isLoadingSurvey, survey } = useBraveUpSurveysApi();
  const { user } = useAuth();
  const { isLoadingReport, report } = useGetReports(survey);
  const [report1] = report;
  const { isLoadingSurveySociogram, sociogram } = useGetSurveysSociogram(user);
  // const sociogramSurveys = sociogram?.surveys.map((survey) => {
  //   return survey.id;
  // });
  const {
    // isLoading: isLoadingResults,
    organizationResults,
  } = useGetDashboardResponses(sociogram);
  console.log('isLoadingReport', isLoadingReport);
  console.log('isLoadingSurvey', isLoadingSurvey);
  console.log('isLoadingSurveySociogram', isLoadingSurveySociogram);

  return (
    <PageLayout>
      <ButtonBackData onClick={() => history.goBack()} />
      <DividerContainer title={t('pages.data.tracking.title')} />

      {isLoadingReport || isLoadingSurvey || isLoadingSurveySociogram ? (
        <BupSpinner size="large" />
      ) : (
        <>
          <p className="tracking-paragraph">
            {t('pages.data.tracking.introText')}
          </p>
          <Row className="tracking-row" justify="space-around">
            <ItemImage
              key="item-image-diagnostic"
              span={10}
              src={Diagnostico}
              text={t('pages.data.tracking.item1Title')}
              textButton1="Solicitar activación"
              button1={[
                <Button
                  className="tracking-row_itemImage__button-activation"
                  type="primary"
                  onClick={() => history.push('/data/tracking/advance-status')}
                  block
                >
                  {t('pages.data.tracking.item1Button1Text')}
                </Button>,
              ]}
              button2={[
                <Button
                  className="tracking-row_itemImage__button-report"
                  type="primary"
                  onClick={() => history.push('/data/tracking/results-report')}
                  disabled={!report1?.url}
                  block
                >
                  {t('pages.data.tracking.item1Button2Text1')}
                  <br />
                  {t('pages.data.tracking.item1Button2Text2')}
                </Button>,
              ]}
            />
            {isSociogram(user) && sociogram ? (
              <ItemImage
                key="item-image-sociogram"
                span={10}
                src={Sociograma}
                text={t('pages.data.tracking.item2Title')}
                button1={
                  organizationResults && organizationResults.length
                    ? [
                        <Button
                          className="activeInstruments-row_itemImage__button-activation"
                          type="primary"
                          onClick={() => history.push('/data/dashboard')}
                          block
                        >
                          {t('pages.data.tracking.item2Button2Text')}
                        </Button>,
                      ]
                    : [
                        <Button
                          className="tracking-row_itemImage__button-coming-soon"
                          disabled
                        >
                          {t('pages.data.tracking.item2Button1Text')}
                        </Button>,
                      ]
                }
                block
              />
            ) : null}
          </Row>
        </>
      )}
    </PageLayout>
  );
};

export default DataTrackingPage;
